<script>
import _ from 'lodash';
import BButton from "@/components/global_components/BButton";

export default {
  functional: true,
  props: {
    toggle: { type: Boolean, default: false },
  },
  render(createElement, context) {
    const classes = !context.props.toggle ? 'is-active' : 'is-inactive' ;

    const customData = {
      class: classes
    }

    context.data.props = context.props;
    _.mergeWith(context.data, customData, function(objValue, srcValue) {
      if (_.isArray(objValue)) return objValue.concat(srcValue);
    });

    return createElement(BButton, context.data, context.children);
  }
}
</script>

<style lang="scss">
.b-button {
  &.is-active {
    box-shadow: inset -7px -7px 14px rgba(255, 255, 255, 0.2),
    inset 8px 8px 16px rgba(0, 0, 0, 0.1);
  }
}
</style>
